import {
  SectionAccordionRoot,
  SectionAccordionDetails,
  SectionAccordionSummary,
  SectionExpandIcon,
  SectionIconBadge,
  SectionSummaryLeading,
  SectionTitle,
} from "./SectionAccordion.styles";
import type { SvgIconProps } from "@mui/material";
import type { ComponentType, ReactNode, SyntheticEvent } from "react";

export interface SectionAccordionProps {
  title: string;
  icon: ComponentType<SvgIconProps>;
  /** Pixel size for the leading section icon. Default 16. */
  iconFontSize?: number;
  /** Optional chips rendered inline after the title in the accordion header. */
  chips?: ReactNode;
  summaryId: string;
  detailsId: string;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  /** When true, the section cannot be expanded and is styled as disabled. */
  disabled?: boolean;
  children: ReactNode;
}

export function SectionAccordion({
  title,
  icon: Icon,
  iconFontSize = 16,
  chips,
  summaryId,
  detailsId,
  expanded,
  onExpandedChange,
  disabled = false,
  children,
}: SectionAccordionProps) {
  return (
    <SectionAccordionRoot
      disableGutters
      disabled={disabled}
      expanded={expanded}
      onChange={(_: SyntheticEvent, isExpanded: boolean) =>
        onExpandedChange(isExpanded)
      }
    >
      <SectionAccordionSummary
        expandIcon={<SectionExpandIcon />}
        aria-controls={detailsId}
        id={summaryId}
      >
        <SectionSummaryLeading>
          <SectionIconBadge>
            <Icon sx={{ fontSize: iconFontSize }} />
          </SectionIconBadge>
          <SectionTitle variant="body2">{title}</SectionTitle>
          {chips}
        </SectionSummaryLeading>
      </SectionAccordionSummary>
      <SectionAccordionDetails id={detailsId}>
        {children}
      </SectionAccordionDetails>
    </SectionAccordionRoot>
  );
}
